<style>
    .foo {
        background: #e7e7e7;
    }

    th .status-column-style {
        max-width: 60px;
    }
</style>
<template>
    <div>
        <div class="foo row">
            <ul class="nav nav-pills">
                <li class="disabled"><h4 style="margin-left:15px; margin:10px" class="text-primary"><b>Patient MAR History</b></h4></li>
            </ul>
        </div>
        <br />
        <div class="row">
            <div class="col-md-4">
                {{Patient}}
            </div>
            <div class="col-md-4 col-md-offset-2 pull-right">
                <div class="form-group">
                    <label class="control-label" for="focusedInput" style="margin-left:5px">Start Dispensation Date</label>
                    <simpledatepicker v-model="selectedDate"></simpledatepicker>
                </div>
            </div>

        </div>
        <transition name="fade" :duration="1000">
            <div v-show="isLoading" class="row" style="width:100%; position:absolute;text-align:center; vertical-align:central">
                <br /><br /><br />
                <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i>
                <span class="sr-only">Loading...</span>
            </div>
        </transition>
        <div v-if="!isLoading && patientRounds.length > 0" class="table-responsive">
            <div class="progress" style="height: 1px;">
                <div class="progress-bar" role="progressbar" v-bind:aria-valuenow="timeleft" aria-valuemin="0" aria-valuemax="100" v-bind:style="{width: timeleft + '%'}"></div>
            </div>
            <table class="table table-striped table-hover">
                <thead>
                    <tr>
                        <th width="200">Name</th>
                        <th width="150">Dob</th>
                        <th width="100" class="text-center" v-for="group in groups">{{group.medRoundGroupName}}</th>
                        <th width="100" class="text-center">Warfarin</th>
                        <th width="100" class="text-center">Non-Scheduled</th>
                        <th />
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in patientRounds">
                        <td>{{ item.patient.firstName }} {{ item.patient.lastName }}</td>
                        <td>{{ formatDate(item.patient.dob)}}</td>
                        <td class="text-center" v-for="groupStatus of item.groups">
                            <a data-toggle="tooltip" data-placement="top" :title="statusText(groupStatus)">
                                <DispensationStatusIcon :status="groupStatus" />
                            </a>
                        </td>
                        <td class="text-center">
                            <DispensationStatusIcon :status="item.warfarinGroupStatus" />
                        </td>
                        <td class="text-center">
                            <a data-toggle="tooltip" data-placement="top" title="Insulin" v-if="item.insulin.length > 0">
                                <span class="fa-stack fa-1x">
                                    <i class="fa fa-circle-o fa-stack-2x"></i>
                                    <strong class="fa-stack-1x">I</strong>
                                </span>
                            </a>
                            <a data-toggle="tooltip" data-placement="top" title="PRN" v-if="item.prn.length > 0">
                                <span class="fa-stack fa-1x">
                                    <i class="fa fa-circle-o fa-stack-2x"></i>
                                    <strong class="fa-stack-1x">P</strong>
                                </span>
                            </a>
                            <a data-toggle="tooltip" data-placement="top" title="No Non-Scheduled Dispensations" v-if="item.prn.length == 0 && item.insulin.length == 0">
                                <i class="fa fa-2x fa-circle-o text-muted">
                                </i>
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="alert alert-warning" v-if="!isLoading && patientRounds.length == 0">
            <h4>No records!</h4>
        </div>
    </div>
</template>


<script>
    import datatable from "../../corecontrols/datatable/datatable.scp.html";
    import simpledatepicker from "../../corecontrols/simpledatepicker/simpledatepicker.scp.html";
    import PatientRoundViewModel from "./PatientRoundViewModel"
    import CarehomeSelector from "../../appcontrols/carehomeselector/carehomeselector.scp.html";
    import { CarehomeDto } from './../../../dto/carehomedto'
    import { UserDto, UserPermissionDto, DispensationRoundGroup } from "./../../../dto/Dtos";
    import { PatientDto } from "./../../../dto/PatientDto";
    import Dal from './../../../scripts/dataaccess'
    import Formatter from "../../corecontrols/formatters/Formatter"
    import moment from "moment";
    import DispensationStatusIcon from "../../appcontrols/dispensationStatusIcon/dispensationStatusIcons.scp.html"

    export default {
        props: {
            patientid: {
                type: String,
                required: false
            }
        },
        watch: {
            selectedDate() {
                console.log("Selected Date changed", this.selectedDate)
                this.loadMarData();
            }
        },
        mounted: function () {
            console.log("Carehome Dispensation mounted with ", this.carehomeid)
        },
        data: function () {
            var formatDate = Formatter.FormatDate;
            var that = this;
            return {
                isLoading: true,
                patient: {},
                groups: [],
                patientRounds: [],
                selectedDate: new Date()
            }
        },
        methods: {
            formatDate: function (dt) {
                return Formatter.FormatDate(dt);
            },
            loadMarData() {

                var dal = new Dal();
                var date = this.selectedDate;
                this.isLoading = true;

                this.patient = {};
                this.groups = []
                this.patientRounds = []


                console.log("Setting Date as " + date);

                var that = this;
                dal.GetPatient(this.patientId).then(pt => {
                    that.patient = pt;
                    that.loadPatientData();
                })
            },
            loadPatientData() {
                var dal = new Dal();
                var startDate = this.selectedDate;

                var promises = [];
                var that = this;
                //console.log("Patients", this.patients);

                for (var index of Array(10)) {
                    var date = moment(startDate).add('days', -1 * index);
                    promises.push(this.loadPatientRounds(patient.pharmacyPatientId, date));
                }

                Promise.all(promises).then(data => {
                    this.groups = [];
                    this.patientRounds = [];

                    for (var patientData of data) {

                        var patientRound = {}
                        patientRound.patient = this.patient;
                        patientRound.groups = {}
                        for (var group of patientData.mar.roundGroups) {
                            if (that.groups.filter(g => g.medRoundGroupName == group.medRoundGroupName).length == 0) {

                                that.groups.push(group);
                            }

                            patientRound.groups[group.medRoundGroupName] = group.medRoundGroupStatus;
                        }

                        patientRound.warfarinGroupStatus = patientData.mar.warfarinGroupStatus ? patientData.mar.warfarinGroupStatus : 0;
                        patientRound.insulin = patientData.mar.insulin ? patientData.mar.insulin : [];
                        patientRound.prn = patientData.mar.prn ? patientData.mar.prn : [];
                        this.patientRounds.push(patientRound);

                    }

                    this.isLoading = false;
                })
            },

            loadPatientRounds(id, date) {
                var dal = new Dal();
                var promise = dal.GetDispensationMar(date, id).then(data => {
                    return { patientid: id, mar: data };
                });
                return promise;
            }
        },
        components: {
            moment,
            datatable,
            Formatter,
            simpledatepicker,
            CarehomeSelector,
            DispensationStatusIcon
        }
    }
</script>



// WEBPACK FOOTER //
// patient-mar-status.scp.html?e24a5b8a